// ==============================================================================
// 物語の「目次」ファイル
// 新しい物語ファイルを作ったら、ここで import して list に追加します。
// ==============================================================================

// 1. 作成した物語ファイルをインポート
import story001 from "./story001";
import story002 from "./story002";
import story003 from "./story003";
import story004 from "./story004";
import story005 from "./story005";
import story006 from "./story006";
import story007 from "./story007";
import story008 from "./story008";
import story009 from "./story009";

// 2. リストにまとめる
export const storyData = [story001, story002, story003, story004, story005,story006, story007, story008, story009];

// 3. ID検索用のヘルパー関数（システム側で使います）
export const getStoryById = (id) => {
  return storyData.find((story) => story.id === id);
};
